<template>
    <div class="bi-content">
        <div class="bi-content-top">
            <div class="opera-tit-btn">
                <div class="btn">
                    <el-button type="success" @click="addProgressItem()">新增进度条</el-button>
                    <el-radio-group v-model="progressBarType" class="btn-group">
                      <el-radio-button label="1">条形</el-radio-button>
                      <el-radio-button label="2">环形</el-radio-button>
                    </el-radio-group>
                    <el-button type="primary" @click="saveData">保存配置</el-button>
                </div>
            </div>
            <div class="form-data">
                <div class="form-data-item" v-for="(item,index) in progressData" :key="index">
                    <div class="form-data-item-name">
                        <input type="text" placeholder="请输入进度条名称" class="form-data-item-name-input" v-model="item.progressName"/>
                        <i class="el-icon-delete form-data-item-name-delete" @click="removeProgressItem(item)"></i>
                    </div>
                    <div class="form-data-item-completion">
                        <div class="item-title">
                            完成值
                        </div>
                        <div class="item-title-content">
                            <div class="item-content-top">
                                <div class="item-title-content-block-one">
                                    <div class="item-title-label">数据来源</div>
                                    <div class="item-title-content">
                                        <el-radio-group v-model="item.completeVal.biDimension" @change="initFormList(item,0)">
                                          <el-radio-button label="0">表单</el-radio-button>
                                          <el-radio-button label="2">报表</el-radio-button>
                                        </el-radio-group>
                                    </div>
                                </div>
                                <div class="item-title-content-block-two">
                                    <div class="item-title-label">数据源</div>
                                    <div class="item-title-content">
                                        <TreeSelect
                                            placeholder="请选择数据源"
                                            :ref="'treeSelect'+item.completeVal.dataModelId"
                                            :multiple="false"
                                            :disableBranchNodes="true"
                                            :callbackParam="item"
                                            :source="1"
                                            :sourceType="0"
                                            :modelId="item.completeVal.dataModelId"
                                            :sourceOptions="item.completeVal.appModelsOptions"
                                            @treeSelectChoose="treeSelectChoose"
                                            :key="loadtime"
                                        />
                                    </div>
                                </div>
                                <div class="item-title-content-block-three">
                                    <div class="item-title-label">
                                        统计字段
                                    </div>
                                    <div class="item-title-content">
                                        <el-select
                                            v-model="item.completeVal.selectYdata"
                                            :disabled="item.completeVal.isCanSelect"
                                            @change="changeYdata(item,0)"
                                            value-key="id"
                                            clearable
                                            placeholder="请选择需要统计的字段"
                                            :multiple="yIsmultiple"
                                            style="width: 100%;"
                                        >
                                            <el-option
                                                v-for="(ite,ind) in item.completeVal.yData"
                                                :key="ite.id"
                                                :label="item.completeVal.biDimension === 2 ? '【' + ite.formName + '】' + ite.name : ite.name"
                                                :value="ite.id"
                                            ></el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div class="item-content-bottom">
                                <div class="item-title-content-block-four">
                                    <div class="item-title-label">
                                        统计方式
                                    </div>
                                        <div class="item-calcul">
                                            <el-select v-model="item.completeVal.calculVal"  value-key="id" placeholder="请选择计算方式" @change="changeCalculVal">
                                                <el-option v-for="(obj,index) in opreaYdata" :key="obj.id" :label="obj.name" :value="obj.id" v-if="obj.showType==item.completeVal.selectYobj.showType"></el-option>
                                            </el-select>
                                        </div>
                                </div>
                                <div class="item-title-content-block-five">
                                    <div class="item-title-label-bun">
                                        <span @click="chooseConditionFields(item,1)">过滤条件</span>
                                    </div>
                                    <div class="item-title-content-search" v-if="item.completeVal.showConditionFields">
                                        <div class="item-title-content-search-box">
                                            <SearchCondition
                                                :ref="item.id+'searchConditon'+'completeVal'"
                                                :conditionFields="item.completeVal.conditionFields"
                                                :isShowLeftModel="false"
                                                :class="'search-field-box'"
                                                :style="'height:auto;max-height:60vh;overflow:auto;width:650px;'"
                                                :key="loadtimeSearch"
                                                >
                                            </SearchCondition>
                                        </div>
                                        <div class="item-title-content-search-btn">
                                            <el-button @click="celSetForm(item,1)">取消</el-button>
                                             <el-button type="success" @click="subSetForm(item,1)">确定</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-data-item-target">
                        <div class="item-title">
                            目标值
                        </div>
                        <div class="item-title-content">
                            <div class="item-content-top">
                               <div class="item-title-content-block-one">
                                   <div class="item-title-label">数据来源</div>
                                   <div class="item-title-content">
                                       <el-radio-group v-model="BIDimension" @change="initFormList(item,2)">
                                         <el-radio-button label="0">表单</el-radio-button>
                                         <el-radio-button label="2">报表</el-radio-button>
                                       </el-radio-group>
                                   </div>
                               </div>
                               <div class="item-title-content-block-two">
                                   <div class="item-title-label">数据源</div>
                                   <div class="item-title-content">
                                       <TreeSelect
                                           placeholder="请选择数据源"
                                           :ref="'treeSelect'+item.targetVal.dataModelId"
                                           :multiple="false"
                                           :disableBranchNodes="true"
                                           :callbackParam="item"
                                           :source="1"
                                           :sourceType="2"
                                           :modelId="item.targetVal.dataModelId"
                                           :sourceOptions="item.targetVal.appModelsOptions"
                                           @treeSelectChoose="treeSelectChoose"
                                           :key="loadtime"
                                       />
                                   </div>
                               </div>
                               <div class="item-title-content-block-three">
                                   <div class="item-title-label">
                                       统计字段
                                   </div>
                                   <div class="item-title-content">
                                       <el-select
                                           v-model="item.targetVal.selectYdata"
                                           value-key="id"
                                           clearable
                                           @change="changeYdata(item,2)"
                                           placeholder="请选择需要统计的字段"
                                           :multiple="yIsmultiple"
                                           style="width: 100%;"
                                       >
                                           <el-option
                                               v-for="(ite,ind) in item.targetVal.yData"
                                               :key="ite.id"
                                               :label="item.targetVal.biDimension === 2 ? '【' + ite.formName + '】' + ite.name : ite.name"
                                               :value="ite.id"
                                           ></el-option>
                                       </el-select>
                                   </div>
                               </div>
                            </div>
                            <div class="item-content-bottom">
                                <div class="item-title-content-block-four">
                                  <div class="item-title-label">
                                      统计方式
                                  </div>
                                  <div class="item-calcul">
                                      <el-select v-model="item.targetVal.calculVal"  value-key="id" placeholder="请选择计算方式" @change="changeCalculVal">
                                          <el-option v-for="(obj,index) in opreaYdata" :key="obj.id" :label="obj.name" :value="obj.id" v-if="obj.showType==item.targetVal.selectYobj.showType"></el-option>
                                      </el-select>
                                  </div>
                                </div>
                                <div class="item-title-content-block-five">
                                    <div class="item-title-label-bun">
                                        <span @click="chooseConditionFields(item,2)">过滤条件</span>
                                    </div>
                                    <div class="item-title-content-search" v-if="item.targetVal.showConditionFields">
                                        <div class="item-title-content-search-box">
                                            <SearchCondition
                                                :ref="item.id+'searchConditon'+'targetVal'"
                                                :conditionFields="item.targetVal.conditionFields"
                                                :isShowLeftModel="false"
                                                :class="'search-field-box'"
                                                :style="'height:60vh;overflow:auto;'"
                                                :key="loadtimeSearch"
                                                >
                                            </SearchCondition>
                                        </div>
                                        <div class="item-title-content-search-btn">
                                            <el-button @click="celSetForm(item,2)">取消</el-button>
                                            <el-button type="success" @click="subSetForm(item,2)">确定</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getApplicationModelTreeList, getBIFormConfigs, getFormFieldListByIds, getModelFormReportList } from '@/data-model';
import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
import { isEmpty, cloneDeep } from 'lodash';
export default {
    components: {
        SearchConditionSide: SearchConditionSide
    },
    props: {
        biConfigData: {
            type: Object,
            default: () => {
                return {
                    modelTit: '',
                    appId: '',
                    formId: '',
                    modelName: '',
                    remarks: '',
                    modelId: ''
                };
            }
        },
        progressBarConfig: {
            type: Object
        }
    },
    data () {
        return {
            appModelsOptions: [],
            XData: [],
            YData: [],
            searchData: [],
            opreaYdata: [{id: 2, name: '计数统计', showType: 0}, {id: 3, name: '加和统计', showType: 1}, {id: 4, name: '平均统计', showType: 1}],
            cakeData: [],
            selectXdata: '',
            selectYdata: '',
            selectSearchData: [],
            selectOpreaYdata: '',
            selectCakedata: '',
            isCanSelect: true,
            formData: {},
            BIDimension: 0,
            chartSettings: {},
            dashboardSetting: {},
            modelId: '',
            allChooseXdata: {},
            allChooseYdata: [],
            formId: '',
            id: '',
            yIsmultiple: false,
            canChoose: false,
            showDataSource: '0',
            progressBarType: 1,
            progressTemplate: {
                id: this.generateUUID(),
                progressName: '',
                targetVal: {
                    biDimension: '0',
                    appModelsOptions: [],
                    selectYdata: '',
                    yData: [],
                    conditionFields: [],
                    showConditionFields: false,
                    selectYobj: {
                        name: ''
                    }
                },
                completeVal: {
                    biDimension: '0',
                    appModelsOptions: [],
                    selectYdata: '',
                    yData: [],
                    dataModelId: '',
                    formId: '',
                    conditionFields: [],
                    showConditionFields: false,
                    selectYobj: {
                        name: ''
                    }
                }
            },
            progressData: [
                {
                    id: this.generateUUID(),
                    progressName: '',
                    targetVal: {
                        biDimension: '0',
                        appModelsOptions: [],
                        selectYdata: '',
                        yData: [],
                        dataModelId: '',
                        formId: '',
                        conditionFields: [],
                        showConditionFields: false,
                        selectYobj: {
                            name: ''
                        }
                    },
                    completeVal: {
                        biDimension: '0',
                        appModelsOptions: [],
                        selectYdata: '',
                        yData: [],
                        dataModelId: '',
                        formId: '',
                        conditionFields: [],
                        showConditionFields: false,
                        selectYobj: {
                            name: ''
                        }
                    }
                }
            ],
            reportList: [],
            formList: [],
            loadtime: '',
            loadtimeSearch: '',
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            formPage: {
                currentPage: 1, // 当前页码
                pageSize: 3, // 每页条数
                totalPageNum: 0 // 总页数
            }
        };
    },
    created () {
        this._initPage();
    },
    methods: {
        async _initPage () {
            let modelTree = await getApplicationModelTreeList({
                currentPage: 1,
                pageSize: 100,
                state: 1,
                aopModelType: 1,
                modelType: 0
            });
            if (!isEmpty(this.progressBarConfig)) { // 修改
                let modelTree = await getApplicationModelTreeList({
                    currentPage: 1,
                    pageSize: 100,
                    aopModelType: 1,
                    state: 1,
                    modelType: 0
                });
                this.formList = modelTree;
                let modelTree1 = await getApplicationModelTreeList({
                    currentPage: 1,
                    pageSize: 100,
                    state: 1,
                    modelType: 2
                });
                this.reportList = modelTree1;
                this.progressBarType = this.progressBarConfig.progressBarType;
                let obj = JSON.parse(this.progressBarConfig.progressBarData);
                for (let i = 0; i < obj.length; i++) {
                    if (obj[i].targetVal.biDimension === '0') {
                        obj[i].targetVal.appModelsOptions = cloneDeep(this.formList);
                    } else if (obj[i].targetVal.biDimension === '2') {
                        obj[i].targetVal.appModelsOptions = cloneDeep(this.reportList);
                    }
                    if (obj[i].completeVal.biDimension === '0') {
                        obj[i].completeVal.appModelsOptions = cloneDeep(this.formList);
                    } else if (obj[i].completeVal.biDimension === '2') {
                        obj[i].completeVal.appModelsOptions = cloneDeep(this.reportList);
                    }
                    let compFormId = obj[i].completeVal.formId;
                    let compParam = {formId: compFormId, BIDimension: obj[i].completeVal.biDimension};
                    let field = await getBIFormConfigs(compParam);
                    let yData1 = obj[i].completeVal.selectYdata;
                    let selectYobj1 = field.allList.find(i => i.id === yData1);
                    if (selectYobj1.type === 'number') {
                        selectYobj1.showType = 1;
                    } else {
                        selectYobj1.showType = 0;
                    }
                    obj[i].completeVal.yData = field.allList;
                    obj[i].completeVal.selectYobj = selectYobj1;
                    let param1 = {formId: obj[i].targetVal.formId, BIDimension: obj[i].targetVal.biDimension};
                    let field1 = await getBIFormConfigs(param1);
                    let yData2 = obj[i].targetVal.selectYdata;
                    let selectYobj2 = field1.allList.find(i => i.id === yData2);
                    if (selectYobj2.type === 'number') {
                        selectYobj2.showType = 1;
                    } else {
                        selectYobj2.showType = 0;
                    }
                    obj[i].targetVal.yData = field1.allList;
                    obj[i].targetVal.selectYobj = selectYobj2;
                }
                this.progressData = obj;
                this.loadtime = new Date().getTime();
            } else {
                this.appModelsOptions = modelTree;
                this.progressTemplate.targetVal.appModelsOptions = modelTree;
                this.progressTemplate.completeVal.appModelsOptions = modelTree;
                this.progressData[0].completeVal.appModelsOptions = modelTree;
                this.progressData[0].targetVal.appModelsOptions = modelTree;
            }
        },
        async initFormList (obj, type) {
            if (type === 0) {
                let param = {
				    currentPage: 1,
				    pageSize: 100000,
				    state: 1,
				    modelType: obj.targetVal.biDimension
                };
                if (this.obj.completeVal.biDimension < 2) {
				    param.aopModelType = 1;
                }
                let modelTree = await getApplicationModelTreeList(param);
                obj.completeVal.appModelsOptions = modelTree;
            } else if (type === 2) {
                let param = {
				    currentPage: 1,
				    pageSize: 100000,
				    state: 1,
				    modelType: obj.targetVal.biDimension
                };
                if (obj.targetVal.biDimension < 2) {
				    param.aopModelType = 1;
                }
                let modelTree = await getApplicationModelTreeList(param);
                obj.targetVal.appModelsOptions = modelTree;
            }
        },
        generateUUID () {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === 'function') {
                d += window.performance.now(); // use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid.replace(RegExp('-', 'g'), '');
        },
        async treeSelectChoose (selected, obj, type) {
            let arr = cloneDeep(this.progressData);
            let currentObj = arr.find(i => i.id === obj.id);
            let param = {formId: selected.formId};
            if (type === 0) {
                param.BIDimension = currentObj.completeVal.biDimension;
            } else if (type === 2) {
                param.BIDimension = currentObj.targetVal.biDimension;
            }
            let field = await getBIFormConfigs(param);
            if (type === 0) {
                currentObj.completeVal.yData = field.allList;
                currentObj.completeVal.selectYdata = '';
                currentObj.completeVal.selectYobj = selected;
                currentObj.completeVal.dataModelId = selected.id;
                currentObj.completeVal.formId = selected.formId;
            } else if (type === 2) {
                currentObj.targetVal.yData = field.allList;
                currentObj.targetVal.selectYdata = '';
                currentObj.targetVal.selectYobj = selected;
                currentObj.targetVal.dataModelId = selected.id;
                currentObj.targetVal.formId = selected.formId;
            }
            this.progressData = arr;
        },
        changeCalculVal () {
            let arr = cloneDeep(this.progressData);
            this.progressData = arr;
        },
        changeYdata (e, type) {
            if (type === 0) {
                let yid = e.completeVal.selectYdata;
                let yarar = e.completeVal.yData;
                let obj = yarar.find(i => i.id === yid);
                if (obj.type === 'number') {
                    obj.showType = 1;
                } else {
                    obj.showType = 0;
                }
                e.completeVal.calculVal = '';
                e.completeVal.selectYobj = obj;
            } else if (type === 2) {
                let yid = e.targetVal.selectYdata;
                let yarar = e.targetVal.yData;
                let obj = yarar.find(i => i.id === yid);
                if (obj.type === 'number') {
                    obj.showType = 1;
                } else {
                    obj.showType = 0;
                }
                e.targetVal.calculVal = '';
                e.targetVal.selectYobj = obj;
            }
        },
        removeProgressItem (obj) {
            for (let i = 0; i < this.progressData.length; i++) {
                let curr = this.progressData[i];
                if (curr.id === obj.id) {
                    this.progressData.splice(i, 1);
                }
            }
        },
        addProgressItem () {
            let obj = cloneDeep(this.progressTemplate);
            obj.id = this.generateUUID();
            obj.targetVal.appModelsOptions = cloneDeep(this.formList);
            obj.completeVal.appModelsOptions = cloneDeep(this.formList);
            this.progressData.push(obj);
        },
        saveData () {
            let paramArray = [];
            for (let i = 0; i < this.progressData.length; i++) {
                let param = {};
                let obj = this.progressData[i];
                param.id = obj.id;
                param.progressName = obj.progressName;
                let targetVal = {};
                targetVal.biDimension = obj.targetVal.biDimension;
                targetVal.selectYdata = obj.targetVal.selectYdata;
                targetVal.dataModelId = obj.targetVal.dataModelId;
                targetVal.formId = obj.targetVal.formId;
                targetVal.type = obj.targetVal.selectYobj.type;
                targetVal.calculVal = obj.targetVal.calculVal === '' ? 1 : obj.targetVal.calculVal;
                targetVal.conditionFields = obj.targetVal.conditionFields;
                param.targetVal = targetVal;
                let completeVal = {};
                completeVal.biDimension = obj.completeVal.biDimension;
                completeVal.selectYdata = obj.completeVal.selectYdata;
                completeVal.dataModelId = obj.completeVal.dataModelId;
                completeVal.formId = obj.completeVal.formId;
                completeVal.type = obj.completeVal.selectYobj.type;
                completeVal.calculVal = obj.completeVal.calculVal === '' ? 1 : obj.completeVal.calculVal;
                completeVal.conditionFields = obj.completeVal.conditionFields;
                param.completeVal = completeVal;
                paramArray.push(param);
            }
            this.$emit('configProgressBar', paramArray, this.progressBarType);
        },
        chooseConditionFields (obj, type) {
            obj.type = type;
            for (let i = 0; i < this.progressData.length; i++) {
                let cur = this.progressData[i];
                cur.completeVal.showConditionFields = false;
                cur.targetVal.showConditionFields = false;
            }
            if (type === 1) {
                let o = obj.completeVal;
                if (o.conditionFields.length === 0) {
                    if (o.dataModelId !== '') {
                        let param = {dataModelId: o.dataModelId, dataFormId: o.formId};
                        this.renderFormList(param, true, null, obj);
                    } else {
                        this.$message.error('请先选择数据源');
                    }
                } else {
                    obj.completeVal.showConditionFields = true;
                    this.progressData = cloneDeep(this.progressData);
                }
            } else if (type === 2) {
                let o = obj.targetVal;
                if (o.conditionFields.length === 0) {
                    if (o.dataModelId !== '') {
                        let param = {dataModelId: o.dataModelId, dataFormId: o.formId};
                        this.renderFormList(param, true, null, obj);
                    } else {
                        this.$message.error('请先选择数据源');
                    }
                } else {
                    obj.targetVal.showConditionFields = true;
                    this.progressData = cloneDeep(this.progressData);
                }
            }
        },
        async renderFormList (model, isInitSearch, searchCondition, obj) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            let tcln = [];
            if (formData.otherData && formData.otherData.tableColumns) {
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        tcln.push(item);
                    }
                });
            }
            loading.close();
            this.refreshSearchConditon(tcln, obj);
        },
        async refreshSearchConditon (columns, obj) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let rtArr = [];
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        rtArr.push(cfs[i]);
                    }
                }
            }
            loading.close();
            this.showFieldSearch(obj, rtArr);
        },
        showFieldSearch (obj, rtArr) {
            if (obj.type === 1) {
                obj.completeVal.conditionFields = rtArr;
                obj.completeVal.showConditionFields = true;
            } else if (obj.type === 2) {
                obj.targetVal.conditionFields = rtArr;
                obj.targetVal.showConditionFields = true;
            }
        },
        celSetForm (obj, type) {
            if (type === 1) {
                obj.completeVal.searchCondition = [];
                obj.completeVal.showConditionFields = false;
            } else if (type === 2) {
                obj.targetVal.searchCondition = [];
                obj.targetVal.showConditionFields = false;
            }
        },
        subSetForm (obj, type) {
            let ref = obj.id + 'searchConditon';
            if (type === 1) {
                ref = ref + 'completeVal';
                let sc = this.$refs[ref][0].getSearchCondition();
                obj.completeVal.conditionFields = cloneDeep(sc);
                obj.completeVal.showConditionFields = false;
            } else if (type === 2) {
                ref = ref + 'targetVal';
                let sc = this.$refs[ref][0].getSearchCondition();
                obj.targetVal.conditionFields = cloneDeep(sc);
                obj.targetVal.showConditionFields = false;
            }
        }
    }
};
</script>

<style lang="less" scoped="scoped">
.bi-content {
    height: 99%;
    width: 96%;
    top: 0vh;
    overflow: auto;
    position: absolute;
    .bi-content-top{
        .opera-tit-btn{
            display: flex;
            height:6vh;
            line-height: 6vh;
            .tit{
                flex: 1;
                font-size: 1.25rem;
                font-weight: 400;
                text-align: left;
            }
            .btn{
                flex: 1;
                text-align: right;
                .btn-group{
                    margin-left: 20px;
                    margin-right: 20px;
                }
            }
        }
        .form-data{
            .form-data-item{
                cursor: pointer;
                border: 2px dashed #bbb5b5;
                padding: 6px;
                margin-top: 10px;
                margin-bottom: 30px;
                .form-data-item-name{
                    position: relative;
                    width: 100%;
                    margin-top: -26px;
                    .form-data-item-name-input{
                       height: 36px;
                       width: 240px;
                       border-radius: 4px;
                       border: 1px solid #c7c5c8;
                       text-indent: 1em;
                       outline: none;
                    }
                    .form-data-item-name-delete{
                      cursor: pointer;
                      position: absolute;
                      right: 0px;
                      font-size: 20px;
                      top: 26px;
                    }
                    .form-data-item-name-delete:hover{
                      color: #1478F0;
                    }
                }
                .form-data-item-completion{
                    display: flex;
                    height: 140px;
                    border: 1px solid #F2F2F2;
                    border-radius: 4px;
                    margin-top: 10px;
                    .item-title{
                        min-width: 100px;
                        height: 140px;
                        line-height: 140px;
                        text-align: center;
                        background-color: #F5F5F5;
                    }
                    .item-title-content{
                        flex: 1;
                        .item-content-top{
                          display: flex;
                          height: 60px;
                          line-height: 60px;
                          width: 100%;
                          .item-title-content-block-one{
                              width: 200px;
                              display: flex;
                              height: 60px;
                              line-height: 60px;
                              .item-title-label{
                                  margin-left: 20px;
                                  height: 60px;
                                  line-height: 60px;
                              }
                              .item-title-content{
                                  height: 60px;
                                  line-height: 60px;
                                  margin-left: 10px;
                              }
                          }
                          .item-title-content-block-two{
                              width: 400px;
                              display: flex;
                              height: 60px;
                              line-height: 60px;
                              .item-title-label{
                                  margin-left: 20px;
                                  height: 60px;
                                  line-height: 60px;
                              }
                              .item-title-content{
                                  height: 36px;
                                  line-height: 36px;
                                  margin-left: 10px;
                                  padding-top: 12px;
                              }
                          }
                          .item-title-content-block-three{
                              width: 400px;
                              display: flex;
                              height: 60px;
                              line-height: 60px;
                              .item-title-label{
                                  margin-left: 20px;
                                  height: 60px;
                                  line-height: 60px;
                              }
                              .item-title-content{
                                  height: 36px;
                                  line-height: 36px;
                                  margin-left: 10px;
                                  padding-top: 12px;
                              }
                          }
                        }
                        .item-content-bottom{
                            display: flex;
                            height: 60px;
                            line-height: 60px;
                            width: 100%;
                            .item-title-content-block-four{
                                display: flex;
                                height: 60px;
                                line-height: 60px;
                                .item-title-label{
                                    margin-left: 20px;
                                    height: 60px;
                                    line-height: 60px;
                                }
                                .item-calcul{
                                    margin-left: 10px;
                                }
                            }
                            .item-title-content-block-five{
                                margin-left: 10px;
                                position: relative;
                                .item-title-label-bun{
                                   margin-left: 10px;
                                   color: #409eff;
                                }
                                .item-title-content-search{
                                    position: absolute;
                                    z-index: 111;
                                    .el-tabs__content{
                                        z-index: 333;
                                    }
                                }
                            }
                        }
                    }
                }
                .form-data-item-target{
                   display: flex;
                   height: 140px;
                   border: 1px solid #F2F2F2;
                   border-radius: 4px;
                   margin-top: 10px;
                   .item-title{
                      min-width: 100px;
                      height: 140px;
                      line-height: 140px;
                      text-align: center;
                      background-color: #F5F5F5;
                   }
                   .item-title-content{
                      flex: 1;
                      .item-content-top{
                        display: flex;
                        height: 60px;
                        line-height: 60px;
                        width: 100%;
                        .item-title-content-block-one{
                            width: 200px;
                            display: flex;
                            height: 60px;
                            line-height: 60px;
                            .item-title-label{
                                margin-left: 20px;
                                height: 60px;
                                line-height: 60px;
                            }
                            .item-title-content{
                                height: 60px;
                                line-height: 60px;
                                margin-left: 10px;
                            }
                        }
                        .item-title-content-block-two{
                            width: 400px;
                            display: flex;
                            height: 60px;
                            line-height: 60px;
                            .item-title-label{
                                margin-left: 20px;
                                height: 60px;
                                line-height: 60px;
                            }
                            .item-title-content{
                                height: 36px;
                                line-height: 36px;
                                margin-left: 10px;
                                padding-top: 12px;
                            }
                        }
                        .item-title-content-block-three{
                            width: 400px;
                            display: flex;
                            height: 60px;
                            line-height: 60px;
                            .item-title-label{
                                margin-left: 20px;
                                height: 60px;
                                line-height: 60px;
                            }
                            .item-title-content{
                                height: 36px;
                                line-height: 36px;
                                margin-left: 10px;
                                padding-top: 12px;
                            }
                        }
                      }
                     .item-content-bottom{
                         display: flex;
                         height: 60px;
                         line-height: 60px;
                         width: 100%;
                         .item-title-content-block-four{
                             display: flex;
                             height: 60px;
                             line-height: 60px;
                             .item-title-label{
                                 margin-left: 20px;
                                 height: 60px;
                                 line-height: 60px;
                             }
                             .item-calcul{
                                 margin-left: 10px;
                             }
                         }
                         .item-title-content-block-five{
                             margin-left: 10px;
                             position: relative;
                             .item-title-label-bun{
                                margin-left: 10px;
                                color: #409eff;
                             }
                             .item-title-content-search{
                                 position: absolute;
                                 z-index: 111;
                                 .el-tabs__content{
                                     z-index: 333;
                                 }
                             }
                         }
                     }
                   }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/ProgressBarConfig.vue